import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import LinkButton from "../components/Button/LinkButton/LinkButton";
import InnerSearchbar from "../components/Searchbar/InnerSearchbar";
import RootModel from "../models/RootModel/RootModel";
import {
  selectCurrentCategoryId,
  selectDataId,
  selectLocalities,
  selectStates,
} from "../store/feed/feedSelector.js";
import {
  TOPICS_SET_CURRENT_CATEGORY,
  TOPICS_SET_DATA_ID,
} from "../store/feed/feedSlice.js";
export default function ExplorePage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLocality, setSearchLocality] = useState("");
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const state = useSelector((state) => state);
  const categoryId = selectCurrentCategoryId(state);
  const dataId = selectDataId(state);
  const states = selectStates(state);
  const localities = selectLocalities(state);
  const dispatch = useDispatch();
  const filteredLocalities = localities.filter((el) =>
    el.name.includes(searchLocality)
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const topicCategoryId = queryParams.get("topic_category_id") || 1;
    dispatch(TOPICS_SET_CURRENT_CATEGORY(topicCategoryId));
    const topicDataId = queryParams.get("data_id");
    if (topicCategoryId > 1) {
      if (!topicDataId) {
        setIsOpen(true);
      } else {
        dispatch(TOPICS_SET_DATA_ID(topicDataId));
      }
    }
  }, [location.search]);

  const navigate = useNavigate();
  const changeUrl = () => {
    let url = location.pathname;
    if (url == "/explore") {
      url = "/explore/opened-projects";
    }
    return url;
  };
  const renderStates = (
    <div className="sl-btn-container">
      {states.map((el) => (
        <LinkButton
          key={el.id}
          linkText={el.name}
          href={changeUrl() + location.search + "&data_id=" + el.id}
          className="tweet-btn w-100"
          onClick={() => {
            setIsOpen(false);
          }}
          externalLink
        />
      ))}
    </div>
  );

  const getQuery = () => {
    let url = "?topic_category_id=" + categoryId;
    if (dataId && dataId != "") {
      url += "&data_id=" + dataId;
    }
    return url;
  };

  const getCurrentLevel = () => {
    if (location.pathname.indexOf("opened")) {
      return 1;
    }
    if (location.pathname.indexOf("constitutions")) {
      return 2;
    }
    if (location.pathname.indexOf("approved")) {
      return 3;
    }
    if (location.pathname.indexOf("delayed")) {
      return 4;
    }
    if (location.pathname.indexOf("rejected")) {
      return 5;
    }
  };

  const renderLocalities = (
    <>
      <div className="input-wrap" style={{ width: "100%" }}>
        <input
          type="text"
          value={searchLocality}
          onChange={(e) => setSearchLocality(e.target.value)}
          placeholder="ابحث"
          className="input"
        />
      </div>
      <div className="sl-btn-container">
        {filteredLocalities.map((el) => (
          <LinkButton
            key={el.id}
            linkText={el.name}
            href={changeUrl() + location.search + "&data_id=" + el.id}
            className="tweet-btn w-100"
            onClick={() => {
              setIsOpen(false);
            }}
            externalLink
          />
        ))}
      </div>
    </>
  );
  return (
    <>
      {isOpen && (
        <div className="login-flow-page">
          <RootModel
            fullHeight
            navigateTo={
              "/explore/opened-projects?topic_category_id=" + categoryId
            }
            setAddonCloseCallback={() => {
              setIsOpen(false);
              navigate("/explore/opened-projects?topic_category_id=1");
            }}
          >
            {categoryId == 2 && renderStates}
            {categoryId == 3 && renderLocalities}
          </RootModel>
        </div>
      )}
      <div className="explorepage two-flex-col-container">
        <div className="col1 explorepage-col1">
          <div className="header-wrapper">
            <h1 style={{ margin: "1rem" }}>
              {categoryId == 1 && "مشاريع المجلس الاتحادي"}
              {categoryId == 2 &&
                `مشاريع الولاية (${
                  states.find((el) => el.id == dataId)
                    ? states.find((el) => el.id == dataId).name
                    : ""
                })`}
              {categoryId == 3 &&
                `مشاريع المحلية (${
                  localities.find((el) => el.id == dataId)
                    ? localities.find((el) => el.id == dataId).name
                    : ""
                })`}
            </h1>
            <div className="top-header">
              <InnerSearchbar
                className="explorepage-searchbar"
                input={searchQuery}
                query={
                  dataId != ""
                    ? `topic_category_id=${categoryId}&topic_level_id=${getCurrentLevel()}&data_id=${dataId}`
                    : `topic_category_id=${categoryId}&topic_level_id=${getCurrentLevel()}`
                }
                setInput={(e) => setSearchQuery(e)}
              />
              {/* <div className="icon-container" onClick={() => setIsOpen(true)}>
              <i className="fas fa-gear"></i>
              <span>
                المنطفة المستهدفة
                <div>({topicCategories[topicCategories.findIndex(el => el.value == currentCategoryId)].label})</div>
              </span>
            </div> */}
            </div>
            <div className="nav-links-wrapper">
              <div className="nav-links">
                <NavLink
                  to={"opened-projects" + getQuery()}
                  className={({ isActive }) =>
                    "header-link " +
                    (isActive ? " active-header-link " : "") +
                    (location.pathname === "/explore"
                      ? "active-header-link"
                      : null)
                  }
                >
                  المشاريع المقترحة
                  <span className="custom-border-bottom"></span>
                </NavLink>

                <NavLink
                  to={"constitutions" + getQuery()}
                  className={({ isActive }) =>
                    "header-link" + (isActive ? " active-header-link" : "")
                  }
                >
                  الاستفتاءات
                  <span className="custom-border-bottom"></span>
                </NavLink>
                <NavLink
                  to={"approved-projects" + getQuery()}
                  className={({ isActive }) =>
                    "header-link" + (isActive ? " active-header-link" : "")
                  }
                >
                  المشاريع المقبولة
                  <span className="custom-border-bottom"></span>
                </NavLink>
                <NavLink
                  to={"rejected-projects" + getQuery()}
                  className={({ isActive }) =>
                    "header-link" + (isActive ? " active-header-link" : "")
                  }
                >
                  المشاريع المرفوضة
                  <span className="custom-border-bottom"></span>
                </NavLink>
                <NavLink
                  to={"delayed-projects" + getQuery()}
                  className={({ isActive }) =>
                    "header-link" + (isActive ? " active-header-link" : "")
                  }
                >
                  المشاريع المؤجلة
                  <span className="custom-border-bottom"></span>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="explore-content">
            {categoryId != "" && <Outlet />}
          </div>
        </div>
      </div>
    </>
  );
}
